import React, { useState, useRef, useEffect } from "react";

const getInitials = (name) =>
  (name ?? "")
    .trim()
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase())
    .join("") || "?";

const RemarksSection = ({
  remarks = [],
  claimId,
  addPublicRemark,
  reloadData,
}) => {
  const [form, setForm] = useState({
    guest_name: localStorage.getItem("insurance_guest_name") || "",
    guest_email: localStorage.getItem("insurance_guest_email") || "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [remarks.length]);


  const clearUser = () => {
    localStorage.removeItem("insurance_guest_name");
    localStorage.removeItem("insurance_guest_email");

    setForm({
      guest_name: "",
      guest_email: "",
      message: "",
    });
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !form.guest_name.trim() ||
      !form.guest_email.trim() ||
      !form.message.trim()
    ) {
      alert("Please fill all fields.");
      return;
    }

    try {
      setLoading(true);

      await addPublicRemark(claimId, form);

      localStorage.setItem(
        "insurance_guest_name",
        form.guest_name
      );

      localStorage.setItem(
        "insurance_guest_email",
        form.guest_email
      );

      setForm((prev) => ({
        ...prev,
        message: "",
      }));

      if (reloadData) {
        reloadData();
      }
    } catch (err) {
      console.log(err);
      alert("Unable to submit remark.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="insurance-card chat-card">
      <h3>Conversation</h3>

      <div className="chat-window">
        {remarks.length === 0 ? (
          <div className="chat-empty">
            <span>💬</span>
            <p>No messages yet. Start the conversation below.</p>
          </div>
        ) : (
          <div className="chat-thread">
            {remarks.map((remark) => {
              const isStaff = Boolean(remark.user_id);
              const name = remark.user_id?.name ?? remark.guest_name ?? "Guest";

              return (
                <div
                  className={`chat-row ${isStaff ? "staff" : "guest"}`}
                  key={remark._id}
                >
                  <div className="chat-avatar">{getInitials(name)}</div>

                  <div className="chat-bubble-wrap">
                    <div className="chat-bubble">
                      <div className="chat-bubble-header">
                        <strong>{name}</strong>
                        {isStaff && <span className="chat-badge">Staff</span>}
                      </div>

                      <p className="chat-message">{remark.message}</p>

                      {remark.attachment && (
                        <a
                          href={remark.attachment}
                          target="_blank"
                          rel="noreferrer"
                          className="chat-attachment"
                        >
                          📎 View Attachment
                        </a>
                      )}
                    </div>

                    <div className="chat-meta">
                      {remark.guest_email && !isStaff && (
                        <span>{remark.guest_email} · </span>
                      )}
                      {new Date(remark.createdAt).toLocaleString()}
                    </div>
                  </div>
                </div>
              );
            })}
            <div ref={bottomRef} />
          </div>
        )}
      </div>

      <form className="chat-composer" onSubmit={handleSubmit}>
        <div className="chat-composer-fields">
          <input
            type="text"
            name="guest_name"
            placeholder="Your Name"
            value={form.guest_name}
            onChange={handleChange}
            readOnly={!!localStorage.getItem("insurance_guest_name")}
          />

          <input
            type="email"
            name="guest_email"
            placeholder="Email Address"
            value={form.guest_email}
            onChange={handleChange}
            readOnly={!!localStorage.getItem("insurance_guest_email")}
          />
        </div>

        <div className="chat-composer-input">
          <textarea
            rows={1}
            name="message"
            placeholder="Type your message..."
            value={form.message}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleSubmit(e);
              }
            }}
          />

          <button type="submit" disabled={loading}>
            {loading ? "..." : "Send"}
          </button>

          <button
            type="button"
            onClick={clearUser}
            className="change-user-btn"
          >
            Change Details
          </button>
        </div>
      </form>
    </div>
  );
};

export default RemarksSection;